var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.111,
    height: 28.111,
    viewBox: "0 0 28.111 28.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "instagram-brands_1_",
    "data-name": "instagram-brands(1)",
    d: "M13.984,38.673a7.207,7.207,0,1,0,7.206,7.207A7.2,7.2,0,0,0,13.984,38.673Zm0,11.893a4.686,4.686,0,1,1,4.685-4.686,4.694,4.694,0,0,1-4.685,4.686Zm9.181-12.188A1.681,1.681,0,1,1,21.484,36.7,1.677,1.677,0,0,1,23.165,38.378Zm4.772,1.706a8.32,8.32,0,0,0-2.27-5.89,8.371,8.371,0,0,0-5.889-2.271c-2.32-.132-9.275-.132-11.6,0a8.359,8.359,0,0,0-5.889,2.264,8.348,8.348,0,0,0-2.27,5.89c-.132,2.321-.132,9.277,0,11.6a8.32,8.32,0,0,0,2.27,5.89,8.382,8.382,0,0,0,5.889,2.271c2.32.132,9.275.132,11.6,0a8.316,8.316,0,0,0,5.889-2.271,8.375,8.375,0,0,0,2.27-5.89C28.069,49.356,28.069,42.406,27.938,40.085Zm-3,14.082a4.743,4.743,0,0,1-2.672,2.672c-1.85.734-6.24.565-8.284.565s-6.441.163-8.284-.565a4.743,4.743,0,0,1-2.672-2.672c-.734-1.85-.564-6.241-.564-8.286s-.163-6.442.564-8.286A4.743,4.743,0,0,1,5.7,34.922c1.85-.734,6.24-.565,8.284-.565s6.441-.163,8.284.565a4.743,4.743,0,0,1,2.672,2.672c.734,1.85.564,6.241.564,8.286S25.674,52.323,24.94,54.167Z",
    transform: "translate(0.075 -31.825)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.59e9ca57.svg";
export { ForwardRef as ReactComponent };